import { generatePath, Link } from 'react-router'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import type { LandingBlockProps } from '@features/landing-page-builder/model/blockRegistry'

import { URL_PAGE_PRODUCT_GROUP } from '@shared/contants'

import styles from './LandingProductGroupsBlock.module.scss'

/*
  products / group with a `groups` list: curated product groups ("готовые
  подборки") shown as cards, each opening its product group page. The card copy
  comes from the payload — the groups themselves are not fetched here, so the
  block costs no extra queries.
*/
interface ProductGroupLinkItem {
  id?: string | number;
  title?: string;
  image?: string;
}

interface ProductGroupsPayload {
  name?: string;
  title?: string;
  groups?: ProductGroupLinkItem[];
}

export default function LandingProductGroupsBlock ({ payload }: LandingBlockProps) {
  const { name, title, groups } = (payload ?? {}) as ProductGroupsPayload

  const heading = name || title

  const links = (groups ?? [])
    .filter((group) => group?.id != null)
    .map((group) => ({
      key: String(group.id),
      title: group.title ?? '',
      image: group.image ?? '',
      href: generatePath(URL_PAGE_PRODUCT_GROUP, { productGroupId: String(group.id) }),
    }))

  if (links.length === 0) {
    return null
  }

  return (
    <section className={styles.root}>
      {heading && <h2 className={styles.root__title}>{heading}</h2>}

      <Swiper
        className={styles.root__slider}
        slidesPerView="auto"
        spaceBetween={16}
        modules={[ Navigation ]}
        navigation
      >
        {links.map((link) => (
          <SwiperSlide className={styles.root__slide} key={link.key}>
            <Link className={styles.card} to={link.href}>
              {link.image && (
                <img className={styles.card__image} src={link.image} alt="" loading="lazy" />
              )}
              <span className={styles.card__title}>{link.title}</span>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}
